module.exports = __webpack_public_path__ + "static/media/signinwelcome.364c3d18.jpg";